import { ORDER_META_KEY, OrderType } from "../../order/constants.js";
import { SOURCE_VALUES } from "../constants.js";
import { getAvailableGiftItems } from "../selectors/getAvailableGiftItems.js";
/**
 * Selects the gift and the freight a holdback gift order consists of. Throws
 * when the gift is not one of the club's gifts or the club has no freight, so
 * callers can validate before they write anything.
 */
export const resolveHoldbackGiftOrder = ({ contractId, giftSku, giftConfig, freight, }) => {
    const gift = getAvailableGiftItems(giftConfig).find(({ sku }) => sku === giftSku);
    if (!gift) {
        throw new Error(`Cannot create holdback gift order for contractId: ${contractId} because giftSku is not one of the club's gifts: ${giftSku}`);
    }
    if (!freight?.sku) {
        throw new Error(`Cannot create holdback gift order for contractId: ${contractId} because the club has no recurring freight`);
    }
    return { gift, freight };
};
/** The cart items of a holdback gift order: one gift and one freight */
export const buildHoldbackCartItems = ({ gift, freight, }) => [
    { sku: gift.sku, quantity: 1 },
    { sku: freight.sku, quantity: 1 },
];
/** The gift is free of charge, the freight keeps its Crystallize price */
export const buildHoldbackGiftPricing = (gift) => ({
    sku: gift.sku,
    quantity: 1,
    price: { gross: 0, net: 0 },
});
const OWN_META_KEYS = [
    ORDER_META_KEY.ORDER.ORDER_TYPE,
    ORDER_META_KEY.ORDER.ORDER_SOURCE,
    ORDER_META_KEY.ORDER.SUBSCRIPTION_CONTRACT_ID,
];
/**
 * The order meta of a holdback gift order. The order type, source and contract
 * id are set here, the rest of the order intent meta is kept.
 */
export const buildHoldbackOrderMeta = ({ contractId, intentMeta, }) => [
    { key: ORDER_META_KEY.ORDER.ORDER_TYPE, value: OrderType.HOLDBACK },
    {
        key: ORDER_META_KEY.ORDER.ORDER_SOURCE,
        value: SOURCE_VALUES.CUSTOMER_SERVICE,
    },
    { key: ORDER_META_KEY.ORDER.SUBSCRIPTION_CONTRACT_ID, value: contractId },
    ...intentMeta.filter(({ key }) => !OWN_META_KEYS.includes(key)),
];
